var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "swipe-magic-nav-config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
        "hide-required-asterisk": "",
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "value" } },
        [
          _c(
            "draggable",
            {
              attrs: { animation: "500", "force-fallback": true },
              model: {
                value: _vm.value.config.value,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "value", $$v)
                },
                expression: "value.config.value",
              },
            },
            _vm._l(_vm.value.config.value, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "upload-item" },
                [
                  _c("div", { staticClass: "item-title" }, [
                    _c("span", [_vm._v(" 图片" + _vm._s(index + 1) + " ")]),
                    _vm.value.config.value.length > 3
                      ? _c("i", {
                          staticClass: "el-icon el-icon-delete",
                          on: {
                            click: function ($event) {
                              return _vm.handleDelUpload(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "upload" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "value." + index + ".imageurl",
                            rules: [
                              { required: true, message: "图片不可为空" },
                            ],
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "upload-item-wrap" },
                            [
                              _c("upload-file", {
                                ref: "uploadBanner",
                                refInFor: true,
                                attrs: {
                                  "link-url": _vm.linkUrl,
                                  tempurl: item.imageurl,
                                  uploadInfo: _vm.uploadInfo,
                                },
                                on: {
                                  emitUploadFile: function (res) {
                                    return _vm.emitUploadFile(res, item)
                                  },
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "btns" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUpload(index)
                                        },
                                      },
                                    },
                                    [_vm._v(" 上传图片 ")]
                                  ),
                                  _vm.pictureList.length > 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectPicture(index)
                                            },
                                          },
                                        },
                                        [_vm._v(" 选择图片 ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "tips",
                              staticStyle: { "text-align": "left" },
                            },
                            [
                              _vm._v(
                                " 建议尺寸为宽度为285px，高度等比例展示，支持png、gif格式图片，大小不超过2M "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 18 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "6.5rem",
                                label: "标题",
                                prop: "value." + index + ".title",
                                rules: [
                                  {
                                    min: 3,
                                    max: 5,
                                    message: "标题长度应为3-5个字符",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "3-5个字",
                                },
                                model: {
                                  value: item.title,
                                  callback: function ($$v) {
                                    _vm.$set(item, "title", $$v)
                                  },
                                  expression: "item.title",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "3rem",
                                label: "颜色",
                                prop: "value." + index + ".title_color",
                              },
                            },
                            [
                              _c("el-color-picker", {
                                model: {
                                  value: item.title_color,
                                  callback: function ($$v) {
                                    _vm.$set(item, "title_color", $$v)
                                  },
                                  expression: "item.title_color",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 18 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "6.5rem",
                                label: "跳转按钮文案",
                                prop: "value." + index + ".btn_text",
                                rules: [
                                  {
                                    min: 2,
                                    max: 4,
                                    message: "跳转按钮文案长度应为2-4个字符",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "2-4个字",
                                },
                                model: {
                                  value: item.btn_text,
                                  callback: function ($$v) {
                                    _vm.$set(item, "btn_text", $$v)
                                  },
                                  expression: "item.btn_text",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "3rem",
                                label: "颜色",
                                prop: "value." + index + ".btn_color",
                              },
                            },
                            [
                              _c("el-color-picker", {
                                model: {
                                  value: item.btn_color,
                                  callback: function ($$v) {
                                    _vm.$set(item, "btn_color", $$v)
                                  },
                                  expression: "item.btn_color",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("config-menu", {
                    key: item.uid,
                    attrs: {
                      value: item,
                      type: _vm.value.key,
                      index: index,
                      info: _vm.info,
                      menuList: _vm.menuList,
                      childrenMenuList: _vm.childrenMenuList,
                      customerModuleList: _vm.customerModuleList,
                      eBookCategoryList: _vm.eBookCategoryList,
                      aBookCategoryList: _vm.aBookCategoryList,
                      customerPackageList: _vm.customerPackageList,
                      systemMenus: _vm.systemMenus,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "el-icon-plus add-upload",
          attrs: { type: "primary" },
          on: { click: _vm.addUpload },
        },
        [_vm._v(" 添加分类")]
      ),
      _c("div", { staticClass: "tips" }, [
        _vm._v(" 上下切换菜单模块可调整顺序 "),
      ]),
      _c(
        "el-form-item",
        { staticClass: "margin_top", attrs: { prop: "margin_top" } },
        [
          _c("div", [
            _vm._v(" 与上方组件的间距 "),
            _c("span", { staticClass: "tips small" }, [
              _vm._v(" （当前组件与上一组件的距离，可填入正负整数） "),
            ]),
          ]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "z_index", attrs: { prop: "z_index" } },
        [
          _c("div", [
            _vm._v(" 层级高度值 "),
            _c("span", { staticClass: "tips small" }, [
              _vm._v(
                " （模块间如遇重叠，层级数值越小展现级别越高、可填入正整数） "
              ),
            ]),
          ]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }